import { createReducer } from "@reduxjs/toolkit"
import { IMealPlanProtocolState } from "../interfaces/mealPlanProtocol/IMealPlanProtocol"
import { setCleansingPlansProtocolData, setMealPlanProtocol, setProtocolMealSuggestions, setSuggestedDishDetailsMap } from "../actions/mealPlanProtocolActions"

const init = {
	protocol: null,
	protocolDescription: "",
	protocolMealPlanSuggestions: {},
	suggestedDishDetailsMap: {},
	eligibilityData: {},
	cleansingPlansProtocol: {},
} as IMealPlanProtocolState

export const mealPlanProtocolReducer = createReducer(init, (builder) => {
	builder
		.addCase(setMealPlanProtocol, (state, action) => {
			state.protocol = action.payload.specialDietPlanProtocol
			state.protocolDescription = action.payload.description
			state.eligibilityData = action.payload
		})
		.addCase(setProtocolMealSuggestions, (state, action) => {
			state.protocolMealPlanSuggestions = action.payload
		})
		.addCase(setSuggestedDishDetailsMap, (state, action) => {
			state.suggestedDishDetailsMap = {
				...state.suggestedDishDetailsMap,
				...action.payload,
			}
		})
		.addCase(setCleansingPlansProtocolData, (state, action) => {
			state.cleansingPlansProtocol = action.payload
		})
})
